/**
 * Visitor tracking module
 * 
 * This module provides functions to track visitors and page views.
 * It uses the browser's navigator API to get information about the user agent
 * and sends this information to the server.
 */

// Track a page view
export const trackPageView = async () => {
  try {
    // Get IP address from a service like ipify
    const ipResponse = await fetch('https://api.ipify.org?format=json');
    const ipData = await ipResponse.json();
    const ip = ipData.ip;
    
    // Get user agent
    const userAgent = navigator.userAgent;
    
    // Get current URL and referrer
    const url = window.location.pathname;
    const referrer = document.referrer;
    
    // Get geolocation data
    let location = null;
    let city = null;
    let country = null;
    
    try {
      const geoResponse = await fetch(`https://ipapi.co/${ip}/json/`);
      const geoData = await geoResponse.json();
      
      if (geoData && !geoData.error) {
        location = `${geoData.city}, ${geoData.country_name}`;
        city = geoData.city;
        country = geoData.country_name;
      }
    } catch (geoError) {
      console.error('Error getting geolocation data:', geoError);
    }
    
    // Send tracking data to server
    await fetch('/api/visitor-stats/track', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ip,
        userAgent,
        url,
        referrer,
        location,
        city,
        country
      })
    });
    
    return true;
  } catch (error) {
    console.error('Error tracking page view:', error);
    return false;
  }
};